import React from 'react';
import styles from './Advt.module.css';
import { useGetParams } from '../../hooks/useGetParams';

const Advt = React.memo(() => {
  const { qrCode1, qrCode2 } = useGetParams();

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Присылайте вариант</div>

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <div className={styles.qrCode}>
            <img src={qrCode1} alt="qrCode1" />
          </div>
        )}
        {qrCode2 && (
          <div className={styles.qrCode}>
            <img src={qrCode2} alt="qrCode1" />
          </div>
        )}
      </div>
    </div>
  );
});

export default Advt;
